import React from "react";
// import eclassmercedesbig from "@/public/images/summer-promo-smartico/mercedes-big.webp";
import { FINAL_PRIZES } from "../utils/finalPrizes";

const PremiiInstantTab = () => {
  return (
    <div className={"font-jost pb-8"}>
      {/*info*/}
      <div className={"text-center"}>
        <div className={"uppercase text-dark-1 font-bold text-lg leading-6 mb-6 lg:text-xl lg:leading-6.5"}>
          Grand finale
        </div>
        <div className={"mb-6 text-sm lg:text-base text-gray-1 leading-5 lg:leading-5.5 font-normal"}>
          We're giving away over <strong className={"text-dark-1 font-semibold"}>£119,000 in prizes</strong> on October
          31st. One final, massive draw to turn your tickets into a life-changing win.
          {/* We're giving away over £119,000 in prizes on March 2nd. One final, massive draw to turn your tickets into a life-changing win. */}
        </div>
      </div>

      {/*???*/}
      {/*<div className="flex justify-center items-center">*/}
      {/*    <div>*/}
      {/*        <div className="flex items-center gap-2 text-gray-2 font-semibold text-xs">*/}
      {/*            <div*/}
      {/*                className="text-primary text-center text-base font-bold leading-none w-14 h-8 flex items-center justify-center py-1 px-3 rounded-lg bg-blue-7">*/}
      {/*                1x*/}
      {/*            </div>*/}
      {/*            Mercedes E-Class*/}
      {/*        </div>*/}
      {/*        /!*<img height={155} width={343} src={eclassmercedesbig.src} />*!/*/}
      {/*    </div>*/}
      {/*</div>*/}

      {/*grid*/}
      <div className={""}>
        <div className="relative min-h-fit grid grid-cols-2 gap-3 max-lg:max-w-[256px] max-lg:mx-auto lg:grid-cols-3">
          {FINAL_PRIZES.map((prize, id) => (
            <div
              className={
                "rounded-lg bg-white relative overflow-hidden flex-center flex-col text-center px-2 py-2 gap-2 shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)]"
              }
              key={id}>
              <div>
                <div
                  className={
                    "text-base lg:text-xl font-bold leading-5.5 lg:leading-6.5 mb-0.5 bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                  }>
                  {prize.count}x
                </div>
                <div
                  className={
                    "text-gray-1 text-xs lg:text-base font-medium leading-4 lg:leading-5.5 min-h-8 lg:min-h-11"
                  }>
                  {prize.prize}
                </div>
              </div>
              <div className={"mt-auto h-[65px] w-full flex-center lg:h-[94px]"}>
                {/*TODO - add correct&dynamic img path*/}
                <img
                  width={98}
                  height={65}
                  className={"w-full h-auto"}
                  src={
                    `/assets/images/christmas-raffle/final-prizes/${prize.imgId}.png`
                    // prizeLogos[
                    //     prize.imgId.split(" ").join("").toLocaleLowerCase()
                    //     ]
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PremiiInstantTab;
